import { Component, Injector, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { IPAnalysisDrawerComponent } from './shared/components/ip-analysis-drawer/ip-analysis-drawer.component';
import { NavigationPermissionHelper } from './core/navigation/navigation-permission.helper';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, IPAnalysisDrawerComponent]
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private router: Router,
        private injector: Injector
    ) {
        console.log('AppComponent constructor');
        // Initialize navigation permission helper for role-based menu filtering
        NavigationPermissionHelper.initialize(this.injector);
    }

    ngOnInit(): void {
        // Handle 404.html redirect - restore original path
        const redirectPath = sessionStorage.getItem('redirectPath');
        if (redirectPath) {
            sessionStorage.removeItem('redirectPath');
            console.log('Restoring redirect path:', redirectPath);
            this.router.navigateByUrl(redirectPath);
        }
    }
}
